export default __webpack_public_path__ + "static/media/logo-with-sub.765438e1.svg";